import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This is the `presentational` component that the AB container utilizes.
 * If you'd like to avoid using react-redux outside of the top of your
 * react root, you can utilize this component directly by passing in the
 * correct props from your root component all the way down to whatever
 * component you want to run an A/B against.
 */

/**
 * Dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SCREEN_SMALL_MAX, SCREEN_MEDIUM_MAX, SCREEN_LARGE } from '@nerdwallet/react-media-queries';
import withinViewport from '../shared/in-viewport';

var fireEEE = function fireEEE(abEvent) {
  if (typeof nwa !== 'undefined') {
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    nwa.track('EXPERIMENT_EXPOSURE_EVENT', _objectSpread({}, abEvent, {
      // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
      uuid: nwa.getUserProp('cookieId')
    }));
  }
};

var SCREEN_SIZES_ARRAY = ['sm', 'md', 'lg'];

var AB =
/*#__PURE__*/
function (_Component) {
  _inherits(AB, _Component);

  function AB() {
    _classCallCheck(this, AB);

    return _possibleConstructorReturn(this, _getPrototypeOf(AB).apply(this, arguments));
  }

  _createClass(AB, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.checkAndFire();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkAndFire();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var experiment = this.props.availableExperiments[this.props.experimentID]; // If this experiment is not running or was loaded via Optimizely, no need to notify analytics

      if (experiment && !experiment.isExternallyLoaded && !experiment.usesEEE) {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.props.deactivateExperiment(this.props.experimentID);
      }
    }
  }, {
    key: "checkAndFire",
    value: function checkAndFire() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var experiment = this.props.availableExperiments[this.props.experimentID];

      if (!experiment) {
        return;
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      var activatedSet = this.props.currentlyActiveExperiments; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var isActivated = activatedSet && !!activatedSet[this.props.experimentID]; // If this experiment is not running or was loaded via Optimizely, no need to notify analytics

      if (!experiment.isExternallyLoaded && !experiment.usesEEE && !isActivated) {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.props.activateExperiment(this.props.experimentID);
      } // Attempt to fire EEE when we have a visible experiment


      if ( // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.inViewport && experiment.usesEEE && !isActivated && this.isCorrectScreen()) {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.props.eeeReported(this.props.experimentID);
        fireEEE({
          test_id: experiment.testID,
          variant_id: experiment.variantID,
          ramp: experiment.ramp
        });
      }
    } // Check the size of the screen based on widths passed in

  }, {
    key: "isCorrectScreen",
    value: function isCorrectScreen() {
      var screenWidth = ''; // Catch in case window doesn't exist

      if (typeof window === 'undefined') {
        return true;
      }

      var width = window.innerWidth;

      if (width === null || width === undefined) {
        return true; // Catch all in case we get into a state where innerWidth doesn't exist
      }

      if (width <= SCREEN_SMALL_MAX) {
        screenWidth = 'sm';
      } else if (width > SCREEN_SMALL_MAX && width <= SCREEN_MEDIUM_MAX) {
        screenWidth = 'md';
      } else if (width >= SCREEN_LARGE) {
        screenWidth = 'lg';
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      return this.props.allowedScreenSizes.indexOf(screenWidth) > -1;
    }
  }, {
    key: "render",
    value: function render() {
      // Handle null case
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (!this.props.children) {
        return false;
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      var experiment = this.props.availableExperiments[this.props.experimentID];
      var bucket = experiment && experiment.variantName;
      var variantToRender;
      var firstChild; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      React.Children.forEach(this.props.children, function (child, index) {
        // Default to first child.
        if (index === 0) {
          firstChild = child;
        } // Only double equals so loose matching can happen particularly for variant forced
        // via query param. The configuration is user defined anyway so loose equals should be fine.
        // eslint-disable-next-line eqeqeq -- directive added automatically by Shepherd migration


        if (bucket && bucket == child.props.variantName) {
          variantToRender = child;
        }
      }); // Defaults to first child if no variants match

      return React.createElement("div", null, variantToRender || firstChild);
    }
  }]);

  return AB;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


AB.displayName = 'AB'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

AB.propTypes = {
  experimentID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  activateExperiment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  deactivateExperiment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  eeeReported: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  availableExperiments: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
  currentlyActiveExperiments: PropTypes.object,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  inViewport: PropTypes.bool,
  // Sizes can only be 'sm', 'md', and 'lg'
  allowedScreenSizes: PropTypes.arrayOf(PropTypes.oneOf(SCREEN_SIZES_ARRAY))
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

AB.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types -- directive added automatically by Shepherd migration
  availableExperiments: {},
  allowedScreenSizes: SCREEN_SIZES_ARRAY
};
export default withinViewport()(AB);